var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"button",staticClass:"an-exportpdf btn btn--text",on:{"click":_vm.print}},[_vm._v(" Als PDF speichern ")])}
var staticRenderFns = []

export { render, staticRenderFns }